module.exports = __webpack_public_path__ + "img/00035.f0f2b36d.webp";